import { useState, useCallback, useRef } from "react";
import api from "../api/client";
import EditableSelect from "../components/EditableSelect";
import { useExpenseOptions } from "../context/ExpenseOptionsContext";

const CSS = `
.up-dropzone { border:2px dashed #c0d0eb; border-radius:10px; padding:40px 24px; text-align:center;
  cursor:pointer; transition:border-color .2s,background .2s; background:#ffffff; margin-bottom:16px; }
.up-dropzone.drag,.up-dropzone:hover { border-color:#059669; background:#f0fdf4; }
.up-dropzone-icon { font-size:36px; margin-bottom:8px; }
.up-dropzone-label { font-size:13px; color:#2a4a78; }
.up-dropzone-label span { color:#059669; font-weight:500; }

.up-btn { display:inline-flex; align-items:center; gap:7px; padding:9px 20px; border-radius:7px;
  border:none; cursor:pointer; font-size:13px; font-weight:600; transition:opacity .15s; font-family:inherit; }
.up-btn:disabled { opacity:.4; cursor:not-allowed; }
.up-btn:not(:disabled):hover { opacity:.88; }
.up-btn-primary { background:#059669; color:#f0fdf4; }
.up-btn-success { background:#2563eb; color:#fff; }
.up-btn-ghost { background:none; border:1px solid #c0d0eb; color:#2a4a78; }
.up-spinner { display:inline-block; width:14px; height:14px; border:2px solid rgba(255,255,255,.2);
  border-top-color:#fff; border-radius:50%; animation:upspin .6s linear infinite; flex-shrink:0; }
.up-spinner-dark { border-color:rgba(0,0,0,.2); border-top-color:#000; }
@keyframes upspin { to{ transform:rotate(360deg); } }

.up-alert { padding:11px 16px; border-radius:8px; font-size:13px; margin-bottom:16px; display:flex; align-items:center; gap:8px; }
.up-alert-success { background:rgba(16,185,129,.08); border:1px solid rgba(16,185,129,.2); color:#059669; }
.up-alert-error   { background:rgba(248,113,113,.08); border:1px solid rgba(248,113,113,.2); color:#dc2626; }

.up-parts-row { display:flex; flex-wrap:wrap; gap:10px; margin-bottom:14px; }
.up-part-chip { position:relative; width:84px; }
.up-part-thumb { width:84px; height:84px; border-radius:8px; object-fit:cover; border:1px solid #c0d0eb;
  background:#f4f8ff; display:block; }
.up-part-num { position:absolute; top:4px; left:4px; background:rgba(6,11,23,.85); color:#fff;
  font-size:10px; font-weight:700; padding:1px 6px; border-radius:4px; }
.up-part-remove { position:absolute; top:-6px; right:-6px; width:20px; height:20px; border-radius:50%;
  background:#dc2626; color:#fff; border:none; cursor:pointer; font-size:12px; font-weight:700;
  display:flex; align-items:center; justify-content:center; line-height:1; }
.up-part-size { font-size:10px; color:#6080aa; text-align:center; margin-top:3px; }
.up-add-part { width:84px; height:84px; border-radius:8px; border:2px dashed #c0d0eb; background:none;
  color:#2a4a78; cursor:pointer; font-size:22px; display:flex; align-items:center; justify-content:center;
  transition:border-color .15s,color .15s; }
.up-add-part:hover { border-color:#059669; color:#059669; }
.up-parts-hint { font-size:11px; color:#6080aa; margin-bottom:16px; }

.up-status-banner { display:flex; align-items:center; gap:10px; padding:14px 16px; border-radius:8px;
  background:#ffffff; border:1px solid #c0d0eb; color:#2a4a78; font-size:13px; margin-bottom:24px; }

.up-result { background:#ffffff; border:1px solid #c0d0eb; border-radius:10px; padding:24px; }
.up-result-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; flex-wrap:wrap; gap:10px; }
.up-shop-name { font-size:16px; font-weight:700; color:#0d1a36; }
.up-total-chip { background:#f4f8ff; border:1px solid #c0d0eb; border-radius:20px; padding:5px 14px; font-size:13px; font-weight:700; color:#2563eb; }

.up-table { width:100%; border-collapse:collapse; }
.up-table th { font-size:11px; font-weight:600; letter-spacing:.06em; text-transform:uppercase; color:#6080aa; padding:0 10px 10px; text-align:left; }
.up-table td { padding:8px 10px; border-bottom:1px solid #f4f8ff; vertical-align:middle; }
.up-table tr:last-child td { border-bottom:none; }
.up-td-name  { color:#0d1a36; font-size:13px; }
.up-td-qty   { color:#2a4a78; font-size:13px; width:50px; }
.up-td-price { color:#2563eb; font-size:13px; font-weight:600; font-variant-numeric:tabular-nums; width:110px; }
.up-td-cat   { width:150px; }
.up-inline-input { background:#f4f8ff; border:1px solid #d5e3f5; border-radius:6px; padding:5px 8px;
  font-size:13px; color:#0d1a36; outline:none; width:100%; font-family:inherit; }
.up-inline-input:focus { border-color:#059669; }
.up-inline-select { background:#f4f8ff; border:1px solid #d5e3f5; border-radius:6px; padding:5px 8px;
  font-size:12px; color:#2a4a78; outline:none; width:100%; font-family:inherit; cursor:pointer; }
.up-inline-select:focus { border-color:#059669; }
.up-meta-row { display:flex; gap:12px; flex-wrap:wrap; align-items:center; margin-bottom:16px; padding-bottom:16px; border-bottom:1px solid #f4f8ff; }
.up-meta-field { display:flex; flex-direction:column; gap:4px; }
.up-meta-label { font-size:10px; font-weight:700; letter-spacing:.07em; text-transform:uppercase; color:#6080aa; }
.up-meta-input { background:#f4f8ff; border:1px solid #d5e3f5; border-radius:6px; padding:6px 10px;
  font-size:13px; color:#0d1a36; outline:none; font-family:inherit; }
.up-meta-input:focus { border-color:#059669; }
.up-meta-select { background:#f4f8ff; border:1px solid #d5e3f5; border-radius:6px; padding:6px 10px;
  font-size:13px; color:#0d1a36; outline:none; font-family:inherit; cursor:pointer; }
.up-meta-select:focus { border-color:#059669; }
.up-save-row { display:flex; justify-content:flex-end; margin-top:20px; padding-top:16px; border-top:1px solid #f4f8ff; }
`;

const MAX_DIMENSION = 1600;   // px, longest side — plenty for OCR/vision, keeps payload small
const SKIP_BELOW_BYTES = 400_000; // don't bother re-encoding files already small enough
const TARGET_MAX_BYTES = 400_000; // per-photo ceiling — keeps a full 10-part upload well under proxy/ingress body-size limits
const START_JPEG_QUALITY = 0.82;
const MIN_JPEG_QUALITY = 0.5;
const MAX_PARTS = 10;

function canvasToBlob(canvas, quality) {
  return new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
}

// Resizes/re-encodes large photos (typical phone camera output) down to a size
// that reliably clears upload/ingress size limits, without a visible quality hit
// for OCR purposes. PDFs and already-small images pass through untouched.
// Re-encodes at progressively lower quality until under TARGET_MAX_BYTES, since a
// single quality pass isn't enough headroom once several parts are combined in one request.
async function compressImage(file) {
  if (!file.type.startsWith("image/") || file.size <= SKIP_BELOW_BYTES) {
    return file;
  }
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = url;
    });
    const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);

    let quality = START_JPEG_QUALITY;
    let blob = await canvasToBlob(canvas, quality);
    while (blob && blob.size > TARGET_MAX_BYTES && quality > MIN_JPEG_QUALITY) {
      quality = Math.max(MIN_JPEG_QUALITY, quality - 0.12);
      blob = await canvasToBlob(canvas, quality);
    }
    if (!blob) return file;
    const compressed = new File(
      [blob],
      file.name.replace(/\.\w+$/, "") + ".jpg",
      { type: "image/jpeg" }
    );
    return compressed.size < file.size ? compressed : file;
  } catch {
    return file;
  } finally {
    URL.revokeObjectURL(url);
  }
}

let partIdSeq = 0;

export default function Upload() {
  const { categories, currencies, addOption } = useExpenseOptions();
  const [parts,       setParts]       = useState([]); // [{id, file, previewUrl}]
  const [drag,         setDrag]        = useState(false);
  const [compressing,  setCompressing] = useState(false);
  const [analyzing,    setAnalyzing]   = useState(false);
  const [saving,       setSaving]      = useState(false);
  const [result,       setResult]      = useState(null);
  const [items,        setItems]       = useState([]);
  const [alert,        setAlert]       = useState({ msg:"", type:"" });
  const [manualEntry,  setManualEntry] = useState(false); // true when adding an expense with no receipt at all
  const addMoreInputRef = useRef(null);
  const analysisSeq = useRef(0); // guards against out-of-order responses when parts change quickly

  const notify = (msg, type="success") => {
    setAlert({ msg, type });
    setTimeout(() => setAlert({ msg:"", type:"" }), 4000);
  };

  const runAnalysis = useCallback(async (currentParts) => {
    const seq = ++analysisSeq.current;
    if (currentParts.length === 0) {
      if (seq === analysisSeq.current) { setResult(null); setItems([]); }
      return;
    }
    setAnalyzing(true);
    try {
      const fd = new FormData();
      currentParts.forEach(p => fd.append("files", p.file));
      const res = await api.post("/expense/ocr/analyze", fd);
      if (seq !== analysisSeq.current) return; // a newer request has since started — discard this stale result
      const data = res.data;
      const newItems = (data.items || []).map(it => ({
        ...it,
        name:  it.item_name  || it.name  || "",
        price: it.unit_price || it.price || it.total_price || 0,
      }));
      setResult({ ...data, date: data.receipt_date || data.date || new Date().toISOString().slice(0,10) });
      setItems(newItems);
    } catch (e) {
      if (seq !== analysisSeq.current) return; // stale request — a newer one is already in flight/done
      let msg = "Analysis failed";
      if (e.response) {
        msg = e.response.status === 413
          ? "Photos too large to upload together — remove a part or retake with a lower-resolution camera setting."
          : (e.response.data?.detail || "Analysis failed");
      } else if (e.request) {
        msg = "Upload failed — check your connection and try again. Large multi-part receipts need a stronger signal.";
      }
      notify(msg, "error");
      setResult(null); setItems([]);
    } finally {
      if (seq === analysisSeq.current) setAnalyzing(false);
    }
  }, []);

  const addFiles = useCallback(async (fileList) => {
    const incoming = Array.from(fileList || []);
    if (!incoming.length) return;

    const room = MAX_PARTS - parts.length;
    if (room <= 0) {
      notify(`Maximum ${MAX_PARTS} parts per receipt — remove one to add another.`, "error");
      return;
    }
    const toAdd = incoming.slice(0, room);
    if (incoming.length > room) {
      notify(`Only added ${toAdd.length} of ${incoming.length} files — maximum ${MAX_PARTS} parts per receipt.`, "error");
    }

    setCompressing(true);
    let updated;
    try {
      const compressedParts = [];
      for (const f of toAdd) {
        const compressed = await compressImage(f);
        compressedParts.push({
          id: ++partIdSeq,
          file: compressed,
          previewUrl: URL.createObjectURL(compressed),
        });
      }
      updated = [...parts, ...compressedParts];
      setParts(updated);
    } finally {
      setCompressing(false);
    }
    await runAnalysis(updated);
  }, [parts, runAnalysis]);

  const removePart = async (id) => {
    const part = parts.find(p => p.id === id);
    if (part) URL.revokeObjectURL(part.previewUrl);
    const updated = parts.filter(p => p.id !== id);
    setParts(updated);
    await runAnalysis(updated);
  };

  const handleDrop = useCallback(e => {
    e.preventDefault(); setDrag(false);
    addFiles(e.dataTransfer.files);
  }, [addFiles]);

  const itemsSubtotal = items.reduce(
    (sum, it) => sum + (parseFloat(it.price || 0) * parseFloat(it.quantity || 1)), 0
  );
  const computedTotal = itemsSubtotal + parseFloat(result?.vat || 0);
  const displayTotal = items.length > 0 ? computedTotal : parseFloat(result?.total_amount || 0);

  const startManualEntry = () => {
    setManualEntry(true);
    setResult({ shop_name: "", date: new Date().toISOString().slice(0,10), currency: "OMR", vat: 0, total_amount: 0 });
    setItems([]);
  };

  const cancelManualEntry = () => {
    setManualEntry(false);
    setResult(null);
    setItems([]);
  };

  const addManualItem = () => {
    setItems(prev => [...prev, { name: "", quantity: 1, price: 0, category: "" }]);
  };

  const removeItem = (i) => {
    setItems(prev => prev.filter((_, j) => j !== i));
  };

  const handleSave = async () => {
    if (!result) return;
    if (!result.date) {
      notify("Please set a receipt date before saving — it won't show up in Expenses without one.", "error");
      return;
    }
    if (manualEntry && items.length === 0) {
      notify("Add at least one item before saving.", "error");
      return;
    }
    setSaving(true);
    try {
      const saveItems = items.map(it => {
        const unitPrice = parseFloat(it.price ?? it.unit_price ?? 0);
        const quantity  = parseFloat(it.quantity ?? 1);
        return {
          ...it,
          item_name:   it.name || it.item_name,
          unit_price:  unitPrice,
          total_price: unitPrice * quantity,
        };
      });
      const finalResult = { ...result, total_amount: displayTotal };
      await api.post("/expense/ocr/save", { ...finalResult, receipt_date: finalResult.date, items: saveItems });
      notify("Receipt saved successfully!");
      parts.forEach(p => URL.revokeObjectURL(p.previewUrl));
      setParts([]); setResult(null); setItems([]); setManualEntry(false);
    } catch (e) { notify(e.response?.data?.detail || "Save failed", "error"); }
    finally { setSaving(false); }
  };

  const setItemField = (i, key, val) => {
    setItems(prev => prev.map((it, j) => j === i ? { ...it, [key]: val } : it));
  };

  return (
    <>
      <style>{CSS}</style>
      <div style={{fontSize:18,fontWeight:700,marginBottom:24,color:'#0d1a36'}}>📤 Upload Receipt</div>

      {alert.msg && (
        <div className={`up-alert up-alert-${alert.type}`}>
          {alert.type==="success"?"✓":"⚠"} {alert.msg}
        </div>
      )}

      {!manualEntry && (parts.length === 0 ? (
        <>
          <div className={`up-dropzone${drag?" drag":""}`}
               onDragOver={e=>{e.preventDefault();setDrag(true);}}
               onDragLeave={()=>setDrag(false)}
               onDrop={handleDrop}
               onClick={()=>document.getElementById("up-file").click()}>
            <div className="up-dropzone-icon">🧾</div>
            <div className="up-dropzone-label">
              Drag & drop a receipt, or <span>click to browse</span><br/>
              <span style={{fontSize:11,color:'#6080aa'}}>
                Supports image files · long receipts can be split into up to {MAX_PARTS} photos
              </span>
            </div>
            <input id="up-file" type="file" hidden multiple accept="image/*"
                   onChange={e=>addFiles(e.target.files)} />
          </div>
          <div style={{textAlign:'center',marginBottom:16}}>
            <button className="up-btn up-btn-ghost" onClick={startManualEntry}>
              🖊️ No receipt? Add expense manually
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="up-parts-row">
            {parts.map((p, i) => (
              <div className="up-part-chip" key={p.id}>
                <span className="up-part-num">Part {i+1}</span>
                <img className="up-part-thumb" src={p.previewUrl} alt={`Part ${i+1}`} />
                <button className="up-part-remove" onClick={()=>removePart(p.id)} title="Remove this part">×</button>
              </div>
            ))}
            {parts.length < MAX_PARTS && (
              <button className="up-add-part" onClick={()=>addMoreInputRef.current?.click()} title="Add another part">
                +
              </button>
            )}
            <input ref={addMoreInputRef} type="file" hidden multiple accept="image/*"
                   onChange={e=>{ addFiles(e.target.files); e.target.value = ""; }} />
          </div>
          <div className="up-parts-hint">
            {parts.length} of {MAX_PARTS} parts — long receipt? Add more photos above; they're combined into one receipt automatically.
          </div>
        </>
      ))}

      {(compressing || analyzing) && (
        <div className="up-status-banner">
          <span className="up-spinner"/>
          {compressing ? "Compressing image…" : "Analyzing with AI…"}
        </div>
      )}

      {result && !analyzing && (
        <div className="up-result">
          <div className="up-result-header">
            <input className="up-inline-input up-shop-name" style={{fontSize:16,fontWeight:700,maxWidth:320}}
                   placeholder="Shop / Vendor name" value={result.shop_name||""}
                   onChange={e=>setResult(r=>({...r,shop_name:e.target.value}))} />
            <div className="up-total-chip">
              {result.currency||"OMR"} {displayTotal.toFixed(3)}
            </div>
          </div>

          {manualEntry && (
            <div className="up-alert up-alert-success" style={{background:"rgba(64,119,244,.08)",borderColor:"rgba(64,119,244,.2)",color:"#2563eb"}}>
              🖊️ Manual entry — no receipt photo. <button className="up-btn-ghost" style={{border:"none",textDecoration:"underline",cursor:"pointer",background:"none",color:"inherit",padding:0,fontSize:13}} onClick={cancelManualEntry}>Cancel and upload a photo instead</button>
            </div>
          )}

          <div className="up-meta-row">
            <div className="up-meta-field">
              <label className="up-meta-label">Date</label>
              <input className="up-meta-input" type="date" value={result.date||""}
                     onChange={e=>setResult(r=>({...r,date:e.target.value}))} />
              {result.date && result.date.slice(0,7) !== new Date().toISOString().slice(0,7) && (
                <div style={{fontSize:11,color:"#b45309",marginTop:4}}>
                  ⚠️ Not in the current month — double-check this is correct.
                </div>
              )}
            </div>
            <div className="up-meta-field">
              <label className="up-meta-label">Currency</label>
              <EditableSelect className="up-meta-select" value={result.currency||"OMR"} options={currencies}
                              onChange={v=>setResult(r=>({...r,currency:v}))}
                              onAddNew={v=>addOption("currency", v)} />
            </div>
            <div className="up-meta-field">
              <label className="up-meta-label">VAT</label>
              <input className="up-meta-input" type="number" min="0" step="0.001" style={{width:100}}
                     value={result.vat ?? ""} placeholder="0.000"
                     onChange={e=>setResult(r=>({...r,vat:e.target.value}))} />
            </div>
          </div>
          {items.length > 0 && (
            <div style={{fontSize:11,color:"#6080aa",marginTop:-10,marginBottom:16}}>
              Items subtotal: {result.currency||"OMR"} {itemsSubtotal.toFixed(3)} + VAT {result.currency||"OMR"} {parseFloat(result.vat||0).toFixed(3)} = total {result.currency||"OMR"} {computedTotal.toFixed(3)}
            </div>
          )}

          <table className="up-table">
            <thead>
              <tr>
                <th>Item</th><th>Qty</th><th>Price</th><th>Category</th><th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td className="up-td-name">
                    <input className="up-inline-input" placeholder="Item name" value={item.name||""} onChange={e=>setItemField(i,"name",e.target.value)} />
                  </td>
                  <td className="up-td-qty">
                    <input className="up-inline-input" type="number" min="1" step="1" style={{width:60}}
                           value={item.quantity ?? 1} onChange={e=>setItemField(i,"quantity",e.target.value)} />
                  </td>
                  <td className="up-td-price">
                    <input className="up-inline-input" type="number" min="0" step="0.001" style={{width:90}}
                           value={item.price ?? 0} onChange={e=>setItemField(i,"price",e.target.value)} />
                  </td>
                  <td className="up-td-cat">
                    <EditableSelect className="up-inline-select" value={item.category||"Others"} options={categories}
                                    onChange={v=>setItemField(i,"category",v)}
                                    onAddNew={v=>addOption("category", v)} />
                  </td>
                  <td>
                    <button className="up-part-remove" style={{position:"static"}} onClick={()=>removeItem(i)} title="Remove this item">×</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{marginTop:12}}>
            <button className="up-btn up-btn-ghost" onClick={addManualItem}>+ Add Item</button>
          </div>

          <div className="up-save-row">
            <button className="up-btn up-btn-success" onClick={handleSave} disabled={saving}>
              {saving ? <><span className="up-spinner"/>Submitting…</> : "✅ Submit"}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
